<app-card Theme="card-primary background-white">
  <div card-content>
    <app-head Theme="head-normal">
      <div head-content>

        <app-importante Theme="banner-important-excendentes-por-restitucion" titulo="Monto a restituir y cuotas en que se ha dividido el pago">
          <!-- <span>{{beneficiarios[0]?.nombres | titlecase}}</span>,  -->
            <p mensage-important>
              <br />
              El Plan de Pago y Ajustes (PPA) de Isapre Colmena, fue aprobado por la Superintendencia de Salud con fecha 8 de octubre de 2024 mediante la Resolución Exenta IF 14404. Revisa <a style="color:#ffffff;text-decoration: underline;" href="https://www.colmena.cl/todo-lo-que-necesitas-saber-sobre-la-ley-corta/" target="_blank">aquí</a> todo lo que necesitas saber sobre esta ley.
            </p>    
            <ng-container callToAction-important>
              <div>
                <div class="box-montos-restitucion-important">
                  <app-card Theme="card-primary shadow background-white">
                    <div card-content>
                      <app-body Theme="body-normal">
                        <ul body-content>
                          <li class="title-fact">
                            <app-text Theme="BodyBold" Text="Monto de Excedente por Restitución"
                              style="color:#757575;"></app-text>
                            <app-text Theme="BodyBold" Text="{{(datosRestituir?.montoRestituir | formatoCostoDesde) + ' UF'}}"  style="color:#0078C8;"></app-text>
                          </li>
                          <li class="title-fact">
                            <app-text Theme="BodyBold" Text="N° de cuotas"
                              style="color:#757575;"></app-text>
                            <app-text Theme="BodyBold" Text="{{datosRestituir?.numeroCuotas}}" style="color:#0078C8;"></app-text>
                          </li>
                          <!-- <li class="separator"></li> -->
                        </ul>
                      </app-body>
                    </div>
                  </app-card>
                </div>
              </div>
            </ng-container>
            <br/>
            <app-text *ngIf="false" callToAction-important Theme="BodyBold" Text="Cada cuota se abonará a tu cuenta de excedentes el (o hasta el ) XX día hábil de cada mes, considerando el valor UF al día XX. " style="color:#ffffff;"></app-text>
        </app-importante> 

      </div>
      <div head-content class="detalle-restitucion">
        <div class="box-montos-restitucion-important">
          <app-card Theme="card-primary shadow background-white">
            <div card-content>
              <app-body Theme="body-normal">
                <ul body-content>
                  <li class="title-fact">
                    <app-text Theme="Heading2" Text="Detalle Restitución" style="color:#0078C8;"></app-text>
                    <div class="inline-text-icon download-plan-pago">
                      <app-text Theme="BodyBold" (click)="downloadPlandePago()" Text="Descargar plan de pago" style="color:#0078C8; text-decoration: underline;cursor:pointer;" ></app-text>
                      <div class="icon-download">
                        <app-icon [Path]="'./assets/img/icon_arrow_down.svg'"></app-icon>
                      </div>
                    </div>
                  </li>
                  <br/>
                  <li class="title-fact">
                    <div class="inline-fact">
                      <app-text Theme="BodyBold" Text="Monto abonado"
                      style="color:#757575;"></app-text>
                      <div class="icon-info">
                        <app-icon style="cursor:pointer;" [Path]="'./assets/img/ico_info.svg'" pTooltip="Monto que a la fecha ha sido restituido mediante abono a la cuenta de Excedentes."
                          tooltipStyleClass="tooltip-colmena-blue"></app-icon>
                      </div>
                    </div>
                    <app-text Theme="BodyBold" Text="{{(datosRestituir?.montoDevengado | formatoCostoDesde) + ' UF'}}" style="color:#0078C8;"></app-text>
                  </li>
                  <li class="title-fact">
                    <div class="inline-fact">
                      <app-text Theme="BodyBold" Text="Monto pendiente"
                      style="color:#757575;"></app-text>
                      <div class="icon-info">
                        <app-icon style="cursor:pointer;" [Path]="'./assets/img/ico_info.svg'" pTooltip="Monto que a la fecha no ha sido restituido."
                        tooltipStyleClass="tooltip-colmena-blue"></app-icon>
                      </div>
                    </div>
                    
                    <app-text Theme="BodyBold" Text="{{(datosRestituir?.montoPendiente | formatoCostoDesde) + ' UF'}}" style="color: #0078C8;"></app-text>
                  </li>
                  <!-- <li class="separator"></li> -->
                </ul>
              </app-body>
            </div>
          </app-card>
        </div>
      </div>
      <app-text *ngIf="false" head-content Theme="title" Text="Próxima cuota a vencer N° X con abono XX/XXXX" style="color:#0078C8"></app-text>
      <!-- <app-text head-content Theme="title" Text="Periodos por restitución" style="color:#0078C8"></app-text> -->
    </app-head>

    <app-text *ngIf="false" head-content Theme="title" Text="Próxima cuota a vencer N° X con abono XX/XXXX" style="color:#0078C8"></app-text>

    <app-body Theme="body-normal">
      <div body-content>
        <div id="time-line-steps">
          <div class="line-stepper">
            <div class="wrapper">
              <div class="btn-back" (click)="moveScroll('back')" [ngClass]="{'disabledControls': !viewControls, 'activeBack': activeIndicador === 'back'}">
                <app-icon [Path]="'./assets/img/arrow_side.svg'"></app-icon>
              </div>
              <div class="btn-next" (click)="moveScroll('next')" [ngClass]="{'disabledControls': !viewControls, 'activeNext': activeIndicador === 'next'}">
                <app-icon [Path]="'./assets/img/arrow_side.svg'"></app-icon>
              </div>
              <div class="mask-scroll-stepper">
                <ul #scrollBarContent  [ngClass]="{'centerChilds': !viewControls}">
                  <li class="step" #stepItem *ngFor="let periodo of periodos; let i = index" (click)="openPeriodo(periodo, i)">
                    <div class="punto">
                      <!--<div [inlineSVG]="'./assets/img/ico_check.svg'"></div>-->
                      <p class="fecha-periodo">{{periodo.periodo}}</p>
                    </div>
                  </li>
                </ul>
              </div>
              
            </div>
          </div>
          <div class="box-tabla-restitucion">
            
              <p-table [columns]="headTable" [value]="dataTable" styleClass="tabla-restitucion">
              <ng-template pTemplate="header" let-columns>
                <tr>
                  <th>Periodo</th>
                  <th>N° de cuota</th>
                  <th>Monto</th>
                  <th>Estado</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-rowData let-columns="columns">
                <tr>
                  <td>{{rowData.dvgPeriodo}}</td>
                  <td>{{rowData.ppaNumCuota}}</td>
                  <td>{{rowData.ppaMonto | formatoCostoDesde}} UF</td>
                  <ng-container *ngIf="rowData.estado === 'S' ">
                    <td><p class="chip-abonado">Abonado</p></td>
                  </ng-container>
                  <ng-container *ngIf="rowData.estado === 'N' ">
                    <td><p class="chip-pendiente">Pendiente</p></td>
                  </ng-container>
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage">
                <tr>
                    <td>Sin movimientos</td>
                </tr>
                </ng-template>
              </p-table>
            
          </div>
        </div>
      </div>
    </app-body>
  </div>
</app-card>



